/*!
 * DHL User Interface Library - https://docs.uilibrary.dhl
 *   9fbef606107a605d69c0edbcd8029e5d
 */
import { S as Sizes, B as ButtonTypes, V as Variants, O as Orientation } from './constants-c94b83bd.js';
import { D as DHL_ICON_WRAPPER } from './constants-74686023.js';

const DHL_BUTTON_SIZES = {
    XS: Sizes.XS,
    SM: Sizes.SM,
    MD: Sizes.MD,
};
const DHL_BUTTON_TYPE = {
    BUTTON: ButtonTypes.button,
    RESET: ButtonTypes.reset,
    SUBMIT: ButtonTypes.submit,
};
const DHL_BUTTON_VARIANTS = {
    PRIMARY: Variants.primary,
    OUTLINE: Variants.outline,
    TEXT: Variants.text,
};
const DHL_BUTTON_ICON_ORIENTATION = {
    RIGHT: Orientation.right,
    LEFT: Orientation.left,
};
const DHL_BUTTON_TEXT_VARIANTS = {
    PRIMARY: Variants.primary,
    LIGHT: Variants.light,
    DARK: Variants.dark,
};
const DHL_BUTTON_RENDER_AS = {
    BUTTON: "button",
    A: "a",
};
const DHL_BUTTON = {
    SIZE: DHL_BUTTON_SIZES,
    TYPE: DHL_BUTTON_TYPE,
    VARIANT: DHL_BUTTON_VARIANTS,
    ICON_SIZE: DHL_ICON_WRAPPER.SIZE,
    ICON_ORIENTATION: DHL_BUTTON_ICON_ORIENTATION,
    TEXT_VARIANT: DHL_BUTTON_TEXT_VARIANTS,
    RENDER_AS: DHL_BUTTON_RENDER_AS,
};

export { DHL_BUTTON as D };

//# sourceMappingURL=constants-cb69b9e1.js.map